import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "documents",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    sendStatus: false,
    esignSendStatus: false,
    deleteStatus: false,
    purgeStatus: false,
    rollbackStatus: false,
    docDownloadData: null,
    reqDocuments: [],
    esignDocuments: [],
    reqDocAddedStatus: false,
    multipleReqDocAddedStatus: false,
    reqDocSendStatus: false,
    uploadedDocumentId: null,
    documentById: null,
    signedDocument: null,
    localDocUploadStatus: null,
    localDocUploadSasUrl: null,
    wfPhases: [],
    ddrmsViewDocs: null,
    reqDocDeleteStatus: null,
    receivedDocStatus: null,
    receivedDocDeleteStatus: null,
  },
  reducers: {
    documentReceived: (documents, action) => {
      documents.list = action.payload;
      documents.reqDocAddedStatus = false;
      documents.multipleReqDocAddedStatus = false;
      documents.sendStatus = false;
      documents.esignSendStatus = false;
      documents.deleteStatus = false;
      documents.purgeStatus = false;
      documents.rollbackStatus = false;
      documents.reqDocDeleteStatus = false;
      documents.localDocUploadStatus = null;
      documents.localDocUploadSasUrl = null;
    },
    documentSent: (documents, action) => {
      documents.sendStatus = true;
    },
    documentDeleted: (documents, action) => {
      documents.deleteStatus = true;
    },
    documentReqDeleted: (documents, action) => {
      documents.reqDocDeleteStatus = true;
    },
    documentPurged: (documents, action) => {
      documents.purgeStatus = true;
    },
    documentRollBacked: (documents, action) => {
      documents.rollbackStatus = true;
    },
    esignDocumentSent: (documents, action) => {
      documents.esignSendStatus = true;
    },
    reqDocumentReceived: (documents, action) => {
      documents.list = action.payload;
    },
    documentDownloaded: (documents, action) => {
      documents.docDownloadData = action.payload;
    },
    reqDocumentAdded: (documents, action) => {
      documents.reqDocAddedStatus = action.payload;
    },
    multipleReqDocumentAdded: (documents, action) => {
      documents.multipleReqDocAddedStatus = action.payload;
    },
    reqDocumentSent: (documents, action) => {
      documents.reqDocSendStatus = action.payload;
    },
    reqDocumentsReceived: (documents, action) => {
      documents.reqDocuments = action.payload;
      documents.reqDocAddedStatus = false;
      documents.reqDocSendStatus = false;
      documents.reqDocDeleteStatus = false;
    },
    esignDocumentsReceived: (documents, action) => {
      documents.esignDocuments = action.payload;
      documents.esignSendStatus = false;
    },
    signedDocumentReceived: (documents, action) => {
      documents.signedDocument = action.payload;
    },
    documentUploaded: (documents, action) => {
      documents.uploadedDocumentId = action.payload;
    },
    documentByIdReceived: (documents, action) => {
      documents.documentById = action.payload;
    },
    localDocumentUploaded: (documents, action) => {
      const payload = action.payload;
      if (!payload) {
        documents.localDocUploadStatus = null;
        documents.localDocUploadSasUrl = null;
        return;
      }

      documents.localDocUploadStatus = payload.uploadId ?? payload;
      documents.localDocUploadSasUrl = payload.uploadUrl ?? null;
    },
    wfPhasesReceived: (dashboard, action) => {
      dashboard.wfPhases = action.payload;
    },
    ddrmsViewFileDocsReceived: (documents, action) => {
      documents.ddrmsViewDocs = action.payload;
    },
    receviedDocStatusUpdated: (documents, action) => {
      documents.receivedDocStatus = action.payload;
    },
    receviedDocDeleted: (documents, action) => {
      documents.receivedDocDeleteStatus = action.payload;
    },
  },
});

export const {
  documentReceived,
  documentSent,
  reqDocumentReceived,
  esignDocumentSent,
  documentDeleted,
  documentPurged,
  documentRollBacked,
  documentDownloaded,
  reqDocumentsReceived,
  reqDocumentAdded,
  multipleReqDocumentAdded,
  documentUploaded,
  reqDocumentSent,
  documentByIdReceived,
  esignDocumentsReceived,
  signedDocumentReceived,
  localDocumentUploaded,
  wfPhasesReceived,
  ddrmsViewFileDocsReceived,
  receviedDocStatusUpdated,
  receviedDocDeleted,
  documentReqDeleted,
} = slice.actions;
export default slice.reducer;

export const loadDocuments = (id) =>
  apiCallBegan({
    url: config.GetApplicationDocuments + id,
    onSuccess: documentReceived.type,
  });

export const loadDocumentById = (id) =>
  apiCallBegan({
    url: config.GetDocumentById + id,
    onSuccess: documentByIdReceived.type,
  });

export const sendDocuments = (data) =>
  apiCallBegan({
    url: config.UpdateDocSentStatus,
    method: "post",
    data: data,
    onSuccess: documentSent.type,
  });

export const sendeSignDocuments = (data) =>
  apiCallBegan({
    url: config.SendeSignDocument,
    method: "post",
    data: data,
    onSuccess: esignDocumentSent.type,
  });

export const sendReqDocuments = (id) =>
  apiCallBegan({
    url: config.SendRequiredDocument + id,
    onSuccess: reqDocumentSent.type,
  });

export const deleteDocument = (id) =>
  apiCallBegan({
    url: config.DeleteUploadedDocument + id,
    onSuccess: documentDeleted.type,
  });

export const updateReceivedDocStatus = (id, status, type) =>
  apiCallBegan({
    url:
      config.UpdateApplicantDocStatus +
      id +
      "&status=" +
      status +
      "&type=" +
      type,
    onSuccess: receviedDocStatusUpdated.type,
  });

export const deleteReceivedDocument = (id, type) =>
  apiCallBegan({
    url: config.DeleteApplicantDoc + id + "&type=" + type,
    method: "delete",
    onSuccess: receviedDocDeleted.type,
  });

export const deleteReqDocument = (id) =>
  apiCallBegan({
    url: config.DeleteRequiredDocument + id,
    onSuccess: documentReqDeleted.type,
  });

export const purgeDocument = (id) =>
  apiCallBegan({
    url: config.PurgeUploadedDocument + id,
    onSuccess: documentPurged.type,
  });

export const rollbackDocument = (id) =>
  apiCallBegan({
    url: config.RollbackUploadedDocument + id,
    onSuccess: documentRollBacked.type,
  });

export const loadReqDocuments = (id) =>
  apiCallBegan({
    url: config.GetRequiredDocument + id,
    onSuccess: reqDocumentsReceived.type,
  });

export const loadEsignDocuments = (id) =>
  apiCallBegan({
    url: config.GetDocusingDocuments + id,
    onSuccess: esignDocumentsReceived.type,
  });

export const loadSignedDocument = (id, type) =>
  apiCallBegan({
    url: config.DownloadSignedDocument + id + "&type=" + type,
    responseType: "blob",
    onSuccess: signedDocumentReceived.type,
  });

export const addReqDocuments = (data) =>
  apiCallBegan({
    url: config.AddRequiredDocument,
    method: "post",
    data: data,
    onSuccess: reqDocumentAdded.type,
  });
export const addMultipleReqDocuments = (data) =>
  apiCallBegan({
    url: config.AddMultipleRequiredDocument,
    method: "post",
    data: data,
    onSuccess: multipleReqDocumentAdded.type,
  });

export const downloadDocument = (id) =>
  apiCallBegan({
    url: config.DownloadDocument + id,
    //responseType: "blob",
    onSuccess: documentDownloaded.type,
  });

export const uploadDocument = (data) =>
  apiCallBegan({
    url: config.ApplicantUploadDocument,
    method: "post",
    data: data,
    onSuccess: documentUploaded.type,
  });

export const loadWfPhasesDocs = (name) =>
  apiCallBegan({
    url: config.GetCodemanager + name,
    onSuccess: wfPhasesReceived.type,
  });

export const uploadLocalDocument = (data) =>
  apiCallBegan({
    url: config.ApplicantUploadDocument,
    method: "post",
    data: data,
    onSuccess: localDocumentUploaded.type,
  });

export const loadDdrmsViewDocs = (id) =>
  apiCallBegan({
    url: config.GetDdrmsViewDocs + id,
    responseType: "blob",
    onSuccess: ddrmsViewFileDocsReceived.type,
  });

export const getDocuments = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.list,
);

export const getDocumentsSendStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.sendStatus,
);
export const getesignDocumentsSendStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.esignSendStatus,
);

export const getReqDocuments = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.reqDocuments,
);

export const getEsignDocuments = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.esignDocuments,
);

export const getSignedDocumentData = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.signedDocument,
);

export const getReqDocAddedStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.reqDocAddedStatus,
);
export const getMultipleReqDocAddedStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.multipleReqDocAddedStatus,
);
export const getReqDocSendStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.reqDocSendStatus,
);

export const getDocumentDeleteStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.deleteStatus,
);

export const getReqDocDeleteStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.reqDocDeleteStatus,
);

export const getDocumentPurgeStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.purgeStatus,
);

export const getDocumentRollbackStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.rollbackStatus,
);

export const getDownloadedDocumentData = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.docDownloadData,
);

export const getUploadDocumentId = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.uploadedDocumentId,
);

export const getLocalDocUploadStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.localDocUploadStatus,
);

export const getLocalDocUploadSasUrl = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.localDocUploadSasUrl,
);

export const getDocumentById = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.documentById,
);

export const getWfPhasesDoc = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.wfPhases,
);

export const getDdrmsViewDocs = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.ddrmsViewDocs,
);

export const getReceivedDocUpdateStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.receivedDocStatus,
);

export const getReceivedDocDeleteStatus = createSelector(
  (state) => state.entities.documents,
  (documents) => documents.receivedDocDeleteStatus,
);
